import { css } from '@emotion/core'
import React from 'react'
import ImagePicker from './InnerComponents/ImagePicker/ImagePicker'
import TextPicker from './InnerComponents/TextPicker/TextPicker'
import { StoryProvider } from '../../providers/StoryProvider'
import useCharacterCounter from '../../hooks/useCharacterCounter/useCharacterCounter'

const layoutCSS = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0px, 1fr));
  grid-template-rows: repeat(2, minmax(0px, 1fr));
  height: 100%;
  width: 100%;
  gap: 20px;
  position: relative;

  @media print {
    height: auto;
  }
`

// Wrapper component for text pickers to calculate character limits based on size
const TextPickerWithLimits = ({ size, pageNumber, positionIndex, isPrintView, ...props }) => {
  const characterLimits = useCharacterCounter(size)

  return (
    <StoryProvider characterLimits={characterLimits}>
      <TextPicker pageNumber={pageNumber} positionIndex={positionIndex} isPrintView={isPrintView} {...props} />
    </StoryProvider>
  )
}

const getComponentFromType = (isPrintView, isPreview, type, pageNumber, size, index, props) => {
  switch (type) {
    case 'image':
      return (
        <ImagePicker
          pageNumber={pageNumber}
          positionIndex={index}
          isPrintView={isPrintView}
          isPreview={isPreview}
          {...props}
        />
      )
    case 'text':
      return (
        <TextPickerWithLimits
          size={size}
          pageNumber={pageNumber}
          positionIndex={index}
          isPrintView={isPrintView}
          {...props}
        />
      )
    default:
      return null
  }
}

const getGridAreaStyle = (size) => {
  switch (size) {
    case 'quarter':
      return 'span 1 / span 1'
    case 'half':
      return 'span 1 / span 2'
    case 'full':
      return 'span 2 / span 2'
    default:
      return 'span 1 / span 1'
  }
}

const PageAssembler = ({ assemblyInstructions, pageNumber, isPrintView = false, isPreview = false }) => {
  return (
    <div css={layoutCSS}>
      {Array.isArray(assemblyInstructions) &&
        assemblyInstructions.map((item, index) => {
          const uniqueKey = `${item.type}-${pageNumber}-${index}-${item.props?.memoryId}`

          return (
            <div key={uniqueKey} style={{ gridArea: getGridAreaStyle(item.size) }}>
              {getComponentFromType(isPrintView, isPreview, item.type, pageNumber, item.size, index, item.props)}
            </div>
          )
        })}
    </div>
  )
}

export default PageAssembler
